module.exports = __webpack_public_path__ + "static/media/Ethax_Factory_Comprehensive_Smart_Contract_Audit_SOKEN.e3427e69.pdf";